import { Identifier } from '../../core/index.js';
import { Json } from '../../util/index.js';
import { CheckerboardBiomeSource } from './CheckerboardBiomeSource.js';
import { FixedBiomeSource } from './FixedBiomeSource.js';
import { MultiNoiseBiomeSource } from './MultiNoiseBiomeSource.js';
import { TheEndBiomeSource } from './TheEndBiomeSource.js';
export var BiomeSource;
(function (BiomeSource) {
    function fromJson(obj) {
        const root = Json.readObject(obj) ?? {};
        const type = Json.readString(root.type)?.replace(/^minecraft:/, '');
        switch (type) {
            case 'fixed': return FixedBiomeSource.fromJson(obj);
            case 'checkerboard': return CheckerboardBiomeSource.fromJson(obj);
            case 'multi_noise': return MultiNoiseBiomeSource.fromJson(obj);
            case 'the_end': return TheEndBiomeSource.fromJson(obj);
            default: return { getBiome: () => Identifier.create('plains') };
        }
    }
    BiomeSource.fromJson = fromJson;
})(BiomeSource || (BiomeSource = {}));
//# sourceMappingURL=BiomeSource.js.map